import { useCallback, useRef, useState } from "react";
import EmailEditor from "react-email-editor";
import { FlyerDimensions } from "../../../types/arts";
import { VARIAVEL_CAMPANHA } from "../../../utils/helpers/Constants";
import { ArtsDialog } from "../DialogArts";

let _updateTemplateImage;

type EditorProps = {
  onChange?: (design: any, html: string) => void;
  template: { formatedData: any; trueData?: any };
};

export const Editor = ({ template, onChange }: EditorProps) => {
  const [dialogImageIsOpen, setDialogImageIsOpen] = useState<boolean>(false);

  const emailEditorRef = useRef(null);
  const handleDialogImage = useCallback(() => {
    setDialogImageIsOpen((prevState) => !prevState);
  }, []);

  const handleChange = useCallback(
    (data: FlyerDimensions) => {
      handleDialogImage();
      _updateTemplateImage({
        height: data.height,
        width: data.width,
        size: 400,
        url: data.url,
      });
    },
    [handleDialogImage]
  );

  const handleChangeContent = useCallback(() => {
    emailEditorRef.current.editor.exportHtml((data) => {
      if (onChange) {
        onChange(data.design, data.html);
      }
    });
  }, [onChange]);

  const onLoad = useCallback(async () => {
    // editor instance is created
    // you can load your template here;
    // const templateJson = {};
    // emailEditorRef.current.editor.loadDesign(templateJson);

    await new Promise((r) => setTimeout(r, 3000));

    if (emailEditorRef?.current?.editor) {
      let events = [
        "body:modified",
        "row:added",
        "row:modified",
        "row:moved",
        "row:removed",
        "contentModified",
        "content:added",
        "content:modified",
        "content:moved",
        "content:removed",
      ];
      events.forEach((e) => {
        emailEditorRef.current.editor.addEventListener(e, (data) => {
          handleChangeContent();
        });
      });
      emailEditorRef.current.editor.loadDesign(
        template?.trueData ? template.trueData.json : null
      );
    }
  }, [template?.trueData, handleChangeContent]);

  const onReady = useCallback(() => {
    // editor is ready
    if (emailEditorRef.current) {
      emailEditorRef.current.editor.exportHtml((data) => {
        if (onChange) {
          onChange(data.design, data.html);
        }
      });
      emailEditorRef.current.registerCallback("selectImage", (_data, done) => {
        handleDialogImage();

        _updateTemplateImage = done;
      });
    }
  }, [onChange, handleDialogImage]);

  return (
    <>
      <EmailEditor
        data-testid="template-content-editor"
        ref={emailEditorRef}
        onLoad={onLoad}
        onReady={onReady}
        minHeight="650px"
        style={{ border: 10 }}
        options={{
          locale: "pt-BR",
          mergeTags: VARIAVEL_CAMPANHA,
        }}
        appearance={{
          theme: "light",
          panels: {
            tools: {
              dock: "right",
            },
          },
        }}
      />
      <ArtsDialog
        open={dialogImageIsOpen}
        onClose={handleDialogImage}
        onChange={handleChange}
      />
    </>
  );
};
